module.exports = __webpack_public_path__ + "static/media/icon-piece-50mmk_01.5539da40.png";